export default __webpack_public_path__ + "static/media/alarm.redflag.ac2fafd3.mp3";